module.exports = ("1.7.0");


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/version.js
// module id = 564
// module chunks = 0